import {
  type FabricLocationGetLocationApi,
  getLocation,
} from './get-location.js';

export type FabricLocationApi = {
  /**
   * 获取当前的地理位置、速度。开启高精度定位，接口耗时会增加，可指定 highAccuracyExpireTime 作为超时时间
   * 如果定位被用户强制关闭, 或者用户点了拒绝, 或者在设置里面禁用了, 返回错误code:`location_permission_disallow`
   */
  getLocation: FabricLocationGetLocationApi;
};

export const fabricLocation: FabricLocationApi = {
  getLocation,
};
